import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useMemo } from 'react';

import { useLeadCardContext } from '@app/components/LeadCard/context';
import { BranchSelectorSkeleton } from '@app/components/LeadCard/ui/BranchSelectorSkeleton';

import './BranchSelector.scss';

export const BranchSelector = () => {
  const {
    branches,
    selectedBranchId,
    selectBranch,
    openCreateBranchModal,
    isBranchesLoading,
  } = useLeadCardContext();

  const hasBranches = useMemo(() => branches.length > 0, [branches]);

  if (isBranchesLoading) {
    return (
      <div className="BranchSelector">
        <BranchSelectorSkeleton />
      </div>
    );
  }

  return (
    <div className="BranchSelector">
      <div className="BranchSelector__scroll">
        {hasBranches &&
          branches.map(({ id, name }) => {
            const isSelected = id === selectedBranchId;

            return (
              <Button
                className="BranchSelector__branch-button"
                type={isSelected ? 'primary' : 'default'}
                size="small"
                key={id}
                onClick={() => selectBranch(id)}
              >
                <span className="BranchSelector__branch-name">{name}</span>
              </Button>
            );
          })}

        <Button
          className="BranchSelector__add-button"
          icon={<PlusOutlined />}
          size="small"
          aria-label="Добавить филиал"
          onClick={openCreateBranchModal}
        />
      </div>
    </div>
  );
};
